import { COMPUTE_MODE, DATA_KIND } from '../../../model/enums';
import { FunctionObj } from '../../../vo/workingdata/function-obj';
import { FreeDataVO } from '../../../vo/core/freedata.vo';
import { FreedataValueVO } from '../../../vo/core/freedatavalue.vo';
import { BaselineEngine } from '../../workingdata/baseline.engine';
import { WizConstants } from '../../../model/constants';
import { WidgetCell, WidgetLine } from '../../../vo/workingdata/widget-line.obj';
import { AkmFDVCell } from '../../../model/interfaces';
import { FunctionCoreEngine } from '../function.core.engine';
import { MeasModeItem } from '../measure.mode.obj';
import { ChronocodeVO } from '../../../vo/core/chronocode.vo';
import { FeiVO } from '../../../vo/workingdata/fei.vo';
import { Model } from '../../../model/model';
import { Baseline, BaselineValue, User, UserApplication } from '@wizeoo/akm-message-lib';

/**
 * fonctions d'appel au référentiel
 */
export class RefFunctions {

  public static functions(model: Model): FunctionObj[] {
      const funcArr: FunctionObj[] = [];
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_REF, 'WHO', [DATA_KIND.STRING]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_REF, 'KEYVAL', [DATA_KIND.STRING, DATA_KIND.STRING]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_REF, 'PARENTKEYVAL', [DATA_KIND.STRING, DATA_KIND.STRING]));
      // recherche d'une valeur de clé de filtre sur un ancêtre
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_REF, 'ANCESTORKEYVAL', [DATA_KIND.STRING, DATA_KIND.STRING, DATA_KIND.INT]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_REF, 'FDVAL', [DATA_KIND.STRING, DATA_KIND.MEASURE, DATA_KIND.STRING]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_REF, 'KEYLIST', [DATA_KIND.STRING, DATA_KIND.STRING, DATA_KIND.STRING, DATA_KIND.STRING])); // collecte la liste des valeurs des enfants de la codif, 2ème param = field / arg, 3ème sortKey 4ème séparateur
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_REF, 'TRIGGER', [DATA_KIND.MEASURE, DATA_KIND.MEASURE]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_REF, 'TIMEDFDVAL', [DATA_KIND.STRING, DATA_KIND.MEASURE, DATA_KIND.MEASURE, DATA_KIND.STRING]));
      // LISTITEMVAL, collecte la valeur d'un élément de la liste
      let func: FunctionObj;
      func = new FunctionObj(model, FunctionObj.KIND_REF, 'LISTITEMVAL', [DATA_KIND.MEASURE, DATA_KIND.STRING]);
      func.isAggregate = false;
      func.isList = true;
      funcArr.push(func);
      
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_REF, 'USERKEYVAL', [DATA_KIND.STRING]));

      // collecte cross Vision
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_REF, FunctionCoreEngine.CROSSED_KEY, [DATA_KIND.STRING, DATA_KIND.NUMBER, DATA_KIND.STRING, DATA_KIND.STRING, DATA_KIND.STRING]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_REF, 'THRESHOLD', [DATA_KIND.MEASURE, DATA_KIND.MEASURE, DATA_KIND.MEASURE, DATA_KIND.MEASURE]));
      
      // injection d'une valeur de champ vers un autre (pour les FDV)
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_REF, 'INJECT', [DATA_KIND.STRING, DATA_KIND.STRING]));
      
      // collecte de la clé de widgetline
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_REF, 'WLKEY', [DATA_KIND.NUMBER]));

      // collecte du créateur d'une BL
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_REF, 'CREATOR', [DATA_KIND.NUMBER]));
      
      // collecte du dernier modificateur d'une BLV
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_REF, 'UPDATER', [DATA_KIND.MEASURE]));

      // prise d'une valeur de workCom
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_REF, 'WORKCOMVAL', [DATA_KIND.MEASURE, DATA_KIND.STRING, DATA_KIND.STRING]));

      // appel de matrice pour collecte de valeurs
      // la clé de matrice
      // les colonnes de requête séparées par | 
      // la colonne cible pour retour de la valeur
      // les mesures cibles contenant les critères pour la requête
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_REF, 'MATRIXVAL', [DATA_KIND.STRING, DATA_KIND.STRING, DATA_KIND.STRING, DATA_KIND.MEASURE], true));

      return funcArr;
  }

  /**
   * accesseur sur une valeur d'un autre vision (même BU)
   *
   * @param visionCode le code de la vision
   * @param stepLevel niveau du step cible
   * @param keys clé de la baseline
   * @param mesure code de la mesure (I ou S, doit être persistée)
   * 
   */
  public static CROSSED(mmi: MeasModeItem, line: WidgetLine, fei: FeiVO): void {
    const visionCode: string = mmi.c[0].r
    const stepLevel: number = Number(mmi.c[1].r);
    const key: string = mmi.c[2].r;
    const measureCode: string = mmi.c[3].r;
    // const aggMethod: string = mmi.c[4].form.replace(new RegExp('"', 'g'), '');
  

    let result: string = null;

    // pas de scenar @@Fake (depuis les forms)
    let scen: string = fei.scenario !== WizConstants.SCEN_FAKE_KEY_CODE ? fei.scenario : WizConstants.BASE_SCENARIO;

    let bl: Baseline = fei.model.dataEngine.getCrossedLine(visionCode, stepLevel, scen, key);
    if(!!bl) {
      // ajout à la map des dépendances
      let meCell: WidgetCell = fei.model.cellMatrixEngine.getWidgetCell(line, mmi.mm.code);
      fei.model.cellMatrixEngine.addCrossDep(bl, meCell);
      
      try {
        let blv: BaselineValue = bl.values[measureCode];
        if(blv) {
          result = blv.valor;
        }
      } catch(e: any) {
      
      }

    }

    // console.log('CROSSED', visionCode, stepLevel, key, measureCode, result);

    mmi.r = result;
  }

  /**
   * déclenche le recalcul et la persistence de la mesure sur modification de la valeur source
   * va déclencher un événement de type updateEntry
   * @param mesure source
   * @param formula calcul de la nouvelle valeur
   * 
   */
  public static TRIGGER(mmi: MeasModeItem, line: WidgetLine, fei: FeiVO): void {
    const sourceMeasure: string = mmi.c[0].form; // la mesure à l'origine du déclenchement, simple ajout pour obtenir l'héritage
    const formula: MeasModeItem = mmi.c[1]; // le champ / sous-champ désiré    
    
    mmi.r = formula.r;
  }

  /**
   * retourne le login du user en cours
   * @param peut importe
   */
  public static WHO(mmi: MeasModeItem, line: WidgetLine, fei: FeiVO): void {
    mmi.r = fei.model?.currentUser?.mail || null;
  }

  /**
   * recherche d'une valeur de clé / complexe ou pas, pour un fdv donné
   * @param mmi mesureMode qui contient l'appel à une référence FDV
   * @param cell la cellule "FDV" identifiée
   * @param lineMeasure la clé du Freedata pour utilisation comme mesure cible dans addCellWithDependancy ??
   * @param cellField le champ demandé sur la cellule
   * @param fei pour accès au modèle
   * @param line ligne qui porte la valeur de FDV
   * @param sourceLine ? ligne qui demande la valeur (et donc qui porte le mmi)
   */
  private static basicFDV(mmi: MeasModeItem, cell : AkmFDVCell, lineMeasure: string, cellField: string, fei: FeiVO, line: WidgetLine, sourceLine: WidgetLine = null ): void {
    // la cellule contient tout.
    if(!!cell && cell.rawVal !== WizConstants.wildcardDomain) {
      if(cellField === WizConstants.FIELD_LABEL) { // si pas de champ, on va prendre le label
        mmi.r = cell.label;
      } else if(cellField === WizConstants.FIELD_CODE) {
        mmi.r = cell.rawVal;
      } else {
        mmi.r = !!cell[cellField] ? cell[cellField].l: cell.rawVal;
      }
      mmi.isErr = false;

      // et simple ajout de la dépedance si nécessaire
      // if(!!sourceLine && sourceLine !== line) { // en cas d'ancestor, marquer la cellule cible comme dépendante de maman
      if(!sourceLine) {
        sourceLine = line; 
      }

      // pour les dépendances sur FD, on inscrit la cellule mère dans les children du FDV
      let targetCell: WidgetCell = fei.model.cellMatrixEngine.getWidgetCell(sourceLine, mmi.mm.code);
      // génération de la dépendance
      fei.model.cellMatrixEngine.addCellWithDependency(line.level, line.scen, line.key, lineMeasure, targetCell);
      // et enregistrement de la mesure sur les AkmFDVCell, en cas de modif du Freedata
      fei.model.cellMatrixEngine.addFDVCellChildren(sourceLine.level, sourceLine.scen, sourceLine.key, mmi.mm.code, cell.fdKey, cell.fdvKey);

    } else {
      mmi.r = ''; 
      mmi.isErr = true;
    }

  }

  /**
   * collecte de la valeur d'un FD
   * part 1: le code du FD et son level BOB#1
   * part 2: le champ du FD. Eventuellement un sous-champ en cas d'objet FLUX@code
   * @param mmi      Etape de calcul concernée
   * @param line Ligne de travail concernée
   * @param fei      Moteur de calcul
   * @param sourceLine qui demande (dans le cas d'un parent / ancestorKeyVal)
   * @param fei      Moteur de calcul de qui demande (dans le cas d'un parent / ancestorKeyVal)
   */
   public static KEYVAL(mmi: MeasModeItem, line: WidgetLine, fei: FeiVO, sourceLine?: WidgetLine): void {
    const key: string = mmi.c[0].form.replace(new RegExp('"', 'g'), ''); // le FD / Chrono cible, par level
    const argKey: string = mmi.c[1].form.replace(new RegExp('"', 'g'), ''); // le champ / sous-champ désiré

    // la valeur chronocode ou FDV pour cette baseline
    let akmFDVCell: AkmFDVCell = BaselineEngine.checkFDVCell(fei, line.bl, key, argKey);
    
    
    // let akmFDVCell = BaselineEngine.checkFDVCell(fei, line.bl, key, argKey);
    if(!akmFDVCell) {
      mmi.r = '';
      mmi.isErr = false;
      return;
    }

    this.basicFDV(mmi, akmFDVCell, key, argKey, fei, line, sourceLine ? sourceLine : line) ; 
  }

  /**
   * récupère une valeur de clé sur le PARENT
   *
   * @param mmi      Etape de calcul concernée
   * @param line Ligne de travail concernée
   * @param fei      Moteur de calcul
   */
  public static PARENTKEYVAL(mmi: MeasModeItem, line: WidgetLine, fei: FeiVO): void {

    if (fei.visionStepLevel <= 1) {
      mmi.r = ''; // j'ai pas de parent...
      return;
    }

    const requiredLevel: number = line.level -1;
    const scenario: string = line.scen;

    // fei cible
    let motherFEI: FeiVO = fei.model.dataEngine.getFei(COMPUTE_MODE.LOCAL,requiredLevel, scenario);

    if (!motherFEI?.computed) { // retour, pas chargé...
      mmi.r = ''; // j'ai pas ENCORE de parent...
      let cell: WidgetCell = fei.model.cellMatrixEngine.getWidgetCell(line, mmi.mm.code);
      fei.model.cellMatrixEngine.addPendingCell(requiredLevel, cell);
      return;
    }

    // baseline parente
    const motherBaseline: WidgetLine = motherFEI.getWidgetLineForKey(scenario, line.bl.pkey); // .source.baselines[baseline.pkey];

    if (!motherBaseline) {
      mmi.isErr = true;
      mmi.r = ''; // j'ai VRAIMENT pas de parent...
      return;
    }

    this.KEYVAL(mmi, motherBaseline, fei, line); // on fait un keyval sur le parent
  }

  /**
   * gestion de la répartition par héritage complet (= DADDY)
   *
   * @param mmi      Etape de calcul concernée
   * @param line     Ligne de travail concernée
   * @param fei      Moteur de calcul
   */
  public static ANCESTORKEYVAL(mmi: MeasModeItem, line: WidgetLine, fei: FeiVO): void {

    const requiredLevel: number = Number(mmi.c[2].form);
    const scenario: string = line.scen;
    if (fei.visionStepLevel <= 1 || fei.visionStepLevel <= requiredLevel) {
      mmi.r = ''; // j'ai pas de parent...
      return;
    }

    // fei cible
    let motherFEI: FeiVO = fei.model.dataEngine.getFei(COMPUTE_MODE.LOCAL, requiredLevel, scenario);


    if (!motherFEI?.computed) { // retour, pas chargé...
      mmi.r = ''; // j'ai pas ENCORE de parent...
      let cell: WidgetCell = fei.model.cellMatrixEngine.getWidgetCell(line, mmi.mm.code);
      fei.model.cellMatrixEngine.addPendingCell(requiredLevel, cell);
      return;
    }
    // construction de la clé cible
    if (!line.bl.splittedKey) {
      line.bl.splittedKey = line.key.split(WizConstants.KEY_SEPARATOR);
    }

    const motherKey: string = line.bl.splittedKey.slice(0, fei.vision.keySizeByLevel.get(requiredLevel)).join(WizConstants.KEY_SEPARATOR);
    // baseline parente
    const motherBaseline: WidgetLine = motherFEI.getWidgetLineForKey(motherFEI.scenario, motherKey); // .source.baselines[motherKey];

    if (!motherBaseline) {
      mmi.isErr = true;
      mmi.r = ''; // j'ai VRAIMENT pas de parent...
      return;
    }

    this.KEYVAL(mmi, motherBaseline, motherFEI, line); // on fait un keyval sur le parent
  }

  /**
   * retourne une valeur de FDV
   *
   * @param mmi  Etape de calcul concernée
   * @param line Ligne de travail concernée
   * @param fei  Moteur de calcul
   */
  public static FDVAL(mmi: MeasModeItem, line: WidgetLine, fei: FeiVO): void {
    const code: string = mmi.c[0].form.replace(new RegExp('"', 'g'), ''); // le Freedata cible
    const shortKey: string = mmi.c[1].r; // attention, la valeur de SHORTCODE du FDV
    let fieldKey: string = mmi.c[2].form.replace(new RegExp('"', 'g'), ''); // le champ du FDV à retourner


    if (!!code && !!shortKey) {
      const fdv: FreedataValueVO = fei.model.freedataEngine.getFreedataValueByShortCode(code, shortKey);
      if (!!fdv) {
        const fdvKey: string = fdv.code; // mais on a besoin du code

        if(!fieldKey) {
          fieldKey = WizConstants.FIELD_LABEL;
        }

        let akmFDVCell: AkmFDVCell;
        // appel fake depuis trigger du FDV grid
        if(!!fei.fakeFDV && fei.fakeFDV.freeDataCode === code.split(WizConstants.CONTEXT_SEPARATOR)[0] && fei.fakeFDV.code === fdvKey) {
          akmFDVCell = { fdKey: code, fdvKey };
          // console.log('checkFDVCell got you fake', fei.fakeFDV); 
        } else {
          akmFDVCell = fei.model.cellMatrixEngine.getFDVCell(code, fdvKey, true);
        }
         
    
        if(!akmFDVCell.rawVal || !akmFDVCell[fieldKey]) { // les valeurs de base ne sont pas alimentés, ou simplement pas le champ demandé
          akmFDVCell = BaselineEngine.feedFDVCell(fei, code, fdvKey, fieldKey, akmFDVCell);
        }

        this.basicFDV(mmi, akmFDVCell, code, fieldKey, fei, line) ; 
      } else { // pas trouvé le FDV
        mmi.r = '';
        mmi.isErr = true;
      }
    } else {
      mmi.r = '';
      mmi.isErr = true;
    }
  }

  /**
   * collection de choix d'un sous-élément de codif
   * @param mmi      Etape de calcul concernée
   * @param line     Ligne de travail concernée
   * @param fei      Moteur de calcul
   *
   */
  public static KEYLIST(mmi: MeasModeItem, line: WidgetLine, fei: FeiVO): void {
    // Fonction I. KEYLIST doit servir POUR LA SELECTION... et le rendu. Nouveau Champ dans les mesures ?
    // ou validation ?
    // Si validation, vérifier reset en cas de modif sur parent
    const key: string = mmi.c[0].form.replace(new RegExp('"', 'g'), ''); // la clé de codif cible sur la bl (la clé de trio, du style HIER#1)
    const field: string = mmi.c[1].r.replace(new RegExp('"', 'g'), '');  // le champ de rendu pour les enfants
    const sortKey: string = mmi.c[2].r.replace(new RegExp('"', 'g'), '');  // le champ de tri
    const separator: string = mmi.c[3].r.replace(new RegExp('"', 'g'), '');  // le séparateur pour rendu

    const fdvKey: string = BaselineEngine.getRawKey(fei, line, key); // le CODE du FDV / Chrono

    if (!fdvKey || fdvKey === WizConstants.err || fdvKey === WizConstants.wildcardDomain) { // pas de valeur de fdv... pas de liste
      mmi.r = '';
      return;
    }
    // on va créer des paires d'objets, pour trier correctement, puis concatener
    const pairs: {sortKey: any, value: string}[] = [];
    const fdv: FreedataValueVO = fei.model.freedataEngine.getFreedataValue(key, fdvKey);
    if (!!fdv) {
      // console.log('keyl fd', fdv);
      const children: FreedataValueVO[] = fei.model.freedataEngine.getFreedataValueByParent(key, fdvKey);
      if (!!children) {
        children.forEach((child: FreedataValueVO) => {

          // mémoriser la dépendance
          // et enregistrement de la mesure sur les AkmFDVCell, en cas de modif du Freedata
          fei.model.cellMatrixEngine.addFDVCellChildren(line.level, line.scen, line.key, mmi.mm.code, child.freeDataCode, child.code);
          // TODO TODO attention au volume

          pairs.push({sortKey: child.argsObjVO[sortKey], value: child.argsObjVO[field]});
        });
      }
    }
    let rawVal: string = '';
    if (pairs && pairs.length > 0) {
      pairs.sort((a, b) => (a.sortKey - b.sortKey));
      rawVal = pairs.slice(0, 20).map(item => item.value).join(separator); // pas plus de 20
    }
    mmi.r = rawVal;
    // console.log('KEYLIST', baseline, rawVal);
  }


  /**
   * comparaison d'une mesure par rapport à des éléments de codif qui servent de seuil
   * @param mmi 
   * @param line 
   * @param fei 
   * @returns 
   */
  public static THRESHOLD(mmi: MeasModeItem, line: WidgetLine, fei: FeiVO): void {
    

    // TODO TODO mémoriser les paires pour traitement rapide...
    
    const prototypeKey: string = mmi.c[0].r; // .form.replace(new RegExp('"', 'g'), ''); // le FD / FDV qui sert de référence soit codeFD, soit codeFD#codeFDV

    const thresoldField: string = mmi.c[1].r; // .form.replace(new RegExp('"', 'g'), ''); // le args qui sert comme seuil (numérique)
    const valueField: string = mmi.c[2].r; //.form.replace(new RegExp('"', 'g'), ''); // le args qui sert de valeur
    const refmeasure: string = mmi.c[3].r; //.form.replace(new RegExp('"', 'g'), ''); // le code de la mesure à comparer

    // const fdvKey: string = BaselineEngine.getRawKey(fei, line, key); // le CODE du FDV / Chrono

    if (!prototypeKey || prototypeKey === WizConstants.err || prototypeKey === WizConstants.wildcardDomain) { // pas de valeur de fdv... pas de liste
      mmi.r = '';
      return;
    }

    if (!(refmeasure?.length > 0)) { // pas de valeur à comparer
      mmi.r = '';
      return;
    }


    let kind: string = 'FDV'; // soit FD soit Chrono
    let children: any[] = null; // FreedataValueVO[] | ChronocodeVO[];

    // détection du type d'élément: FD, FDV ou Chrono
    let splitParts: string[] = prototypeKey.split(WizConstants.CONTEXT_SEPARATOR);
    if(splitParts[0] === 'CHRONO') {
      kind = 'CHRONO';
    }

    // on va créer des paires d'objets, pour trier correctement
    let pairs: {sortKey: number, value: string}[] = [];
    const thresKey: string = [prototypeKey, thresoldField, valueField].join(WizConstants.KEY_SEPARATOR);
    
    // on a pas encore construit les paires
    if(!fei.model.cellMatrixEngine.getFDCells(splitParts[0]).pairMap.has(thresKey)) {
      if(splitParts.length === 1) { // on cherche un FD
        const fd: FreeDataVO = fei.model.freedataEngine.getFreeData(prototypeKey);
        if (!!fd) { // pas trouvé le FD
          kind = 'FDV';
          children = fei.model.freedataEngine.getFreedataValueByParent(splitParts[0], null);
        }
      } else { // soit FDV soit CHRONO
        if(splitParts[0] === WizConstants.CHRONO) {
          let chrono: ChronocodeVO = fei.model.chronocodeEngine.getChronocode(fei.vision.chronoCode);
          if (!!chrono) { // pas trouvé le chrono
          // console.log('chrono', chrono);
            kind = 'CHRONO';
            children = fei.model.chronocodeEngine.getChronocodesByLevel(chrono.code, Number(splitParts[1]));
          }
        } else { // on cherche le FDV
          const fdv: FreedataValueVO = fei.model.freedataEngine.getFreedataValueByShortCode(splitParts[0], splitParts[1]);
          if (!!fdv) {        
            kind = 'FDV';
            children = fei.model.freedataEngine.getFreedataValueByParent(splitParts[0], fdv.code);
          }
  
        }
      }
  
      if((children?.length > 0)) { // pas de valeurs de seuil
        if (kind === 'FDV') {
          children.forEach((child: FreedataValueVO) => {
            try {
              pairs.push({sortKey: Number(child.argsObjVO[thresoldField]), value: child.argsObjVO[valueField]});
            } catch(e: any) {}
    
          });
        } else if (kind === 'CHRONO') { // chrono
          children.forEach((child: ChronocodeVO) => {
            try {
              pairs.push({
                sortKey: Number(fei.model.chronocodeEngine.getChronoValue(child, thresoldField)),
                value: fei.model.chronocodeEngine.getChronoValue(child, valueField)});
            } catch(e: any) {}
          }); 
        }
    
        if (pairs && pairs.length > 0) { // pn tri les paires
          pairs.sort((a, b) => (a.sortKey - b.sortKey));
          fei.model.cellMatrixEngine.getFDCells(splitParts[0]).pairMap.set(thresKey, pairs);
        }
      }
    }
    
    pairs = fei.model.cellMatrixEngine.getFDCells(splitParts[0])?.pairMap?.get(thresKey);
    
    // mémoriser la dépendance
    if (kind === 'FDV') {
      fei.model.cellMatrixEngine.addFDCellChildren(line.level, line.scen, line.key, mmi.mm.code, splitParts[0]);
    }

    let rawVal: number = Number(refmeasure) || -1;
    let result: string = '';
    if (pairs && pairs.length > 0) {

      pairs.forEach(pair => {
        if(rawVal >= pair.sortKey) {
          result = pair.value;
        } else {
          return;
        }
      }); 
    } 

    mmi.r = result;
  }

  /**
   * collecte de la valeur d'un élément de la liste
   * @param1 : la mesure cible sur les enfants
   * @param mmi      Etape de calcul concernée
   * @param 1: la mesure de type liste
   * @param 2 le code du FDV recherché
   */
  public static LISTITEMVAL(mmi: MeasModeItem): void {
    const rawList: MeasModeItem = mmi.c[0]; // le résultat de la mesure. C'est une liste (ou rien)
    const targetKey: string = mmi.c[1]?.r; // la clé recherchée (le code du FDV)
    let result: string = null;
    if(rawList?.r && targetKey) {
      try {
        let rawobj = JSON.parse(rawList.r);
        let popLast: string;
        Object.keys(rawobj).forEach((s: string) => {
          if(s) {
            popLast = s.split(WizConstants.KEY_SEPARATOR).pop();
            if(popLast === targetKey) {
              result = rawobj[s].toString();
            }
          }
        });
      } catch(e: any) {
        console.log('invalid list itemval: ', rawList.r, targetKey);
      }
    }
    mmi.r = result;
  }

  /**
   * retourne une valeur de clé pour un param sur user
   * @param le code#level recherché
   */
  public static USERKEYVAL(mmi: MeasModeItem, line: WidgetLine, fei: FeiVO): void {
    // TODO TODO va poser problème en mode compute (pas le user dispo)
    const targetKey: string = mmi.c[0]?.r; // la clé recherchée (le code#level)
     
    // console.log('user ?', fei.model?.currentUser);
    let user: User = fei.model?.currentUser;
    let result: Set<string> = null;
    if(user) {
      if(!fei.model.userTagMap) { // construction de la map user
        let userApp: UserApplication = null;
        
        user.userApplications.forEach(ua => {
          if( ua.domain === fei.vision.domain && 
              ua.businessUnitCode === fei.vision.businessUnitCode && 
              ua.visionCode === fei.vision.code &&
            ua.perimeter === 'APP') {
              userApp = ua;
                // c'est la bon APP 
                // TODO TODO prendre les profils
                // TODO TODO jouer une seule fois
              }
        });
        fei.model.freedataEngine.feedTags(userApp?.tags);
      }
      result = fei.model.userTagMap.get(targetKey);
    }

    if(result?.size > 0) {
      mmi.r = [...result][0];
    } else {
      mmi.r = '';
    }
  }

  /**
   * injection d'une valeur de champ dans un autre (FDV)
   * Si la propriété source est un args de type objet, on prend juste la valeur (code)
   * ici line est un FreedataValue
   * @param
   * @result code du champ cible|valeur du champ source
   */
  public static INJECT(mmi: MeasModeItem, line: WidgetLine, fei: FeiVO): void {
    
    const from: string = mmi.c[0].r; // la mesure à l'origine du déclenchement
    const to: string = mmi.c[1].r; // le champ cible   
    
    let fdv: FreedataValueVO = line as FreedataValueVO;
    let result: string = fdv.argsObjVO[from];
    if(!!result) {
      result = result.split(WizConstants.CONTEXT_SEPARATOR).pop(); 
    } 
    result = [WizConstants.INJECT_RESPONSE_KEY, to, result].join(WizConstants.KEY_SEPARATOR);
    mmi.r = result;

    // console.log('INJECT', from, to, mmi.r);
  }
 
  /**
   * collecte de la clé d'une widgetline
   * @param mmi      Etape de calcul concernée
   * @param line Ligne de travail concernée
   * @param fei      Moteur de calcul
   */
   public static WLKEY(mmi: MeasModeItem, line: WidgetLine, fei: FeiVO): void {

    let result: string = line.key;
    mmi.r = result;
  }

  /**
   * collecte du créateur d'une BL
   * @param mmi      Etape de calcul concernée
   * @param line Ligne de travail concernée
   * @param fei      Moteur de calcul
   */
   public static CREATOR(mmi: MeasModeItem, line: WidgetLine, fei: FeiVO): void {
    let result: string = line.bl?.createBy;
    mmi.r = result;
  }

  /**
   * collecte du dernier modificateur d'une BLV
   * @param mmi      Etape de calcul concernée
   * @param line Ligne de travail concernée
   * @param fei      Moteur de calcul
   */
   public static UPDATER(mmi: MeasModeItem, line: WidgetLine, fei: FeiVO): void {
    const blvKey: string = mmi.c[0]?.r; // la mesure cible
    let result: string = '';
    try {
      let blv: BaselineValue = line.bl?.values[blvKey];
      if(!!blv) {
        result = blv.updateBy;
      }
    } catch(e: any) {
      console.log('no updater', e, blvKey);
    }
    
    mmi.r = result;
  }


  /**
   * retourne une valeur de clé pour un workcom
   * @param la mesure de type workcom
   * @param le champ désiré
   */
  public static WORKCOMVAL(mmi: MeasModeItem, line: WidgetLine, fei: FeiVO): void {
    
    // TODO TODO passer first / lasr
    const wcKey: string = mmi.c[0]?.r; // la clé de workcom
    const targetKey: string = mmi.c[1]?.r; // la clé recherchée 
    const who: string = mmi.c[2]?.r; // first / last 
    let result: string = fei.model.workflowEngine.getValue(wcKey, targetKey, who);
    
    mmi.r = result;   
  }

  /**
   * retourne une valeur de FDV
   *
   * @param mmi  Etape de calcul concernée
   * @param line Ligne de travail concernée
   * @param fei  Moteur de calcul
   */
  public static TIMEDFDVAL(mmi: MeasModeItem, line: WidgetLine, fei: FeiVO): void {
    const code: string = mmi.c[0].form.replace(new RegExp('"', 'g'), ''); // le Freedata cible
    const shortKey: string = mmi.c[1].r; // attention, la valeur de SHORTCODE du FDV
    const targetDate: number = Number(mmi.c[2].r); // la date cible
    let fieldKey: string = mmi.c[3].form.replace(new RegExp('"', 'g'), ''); // le champ du FDV à retourner


    if (!!code && !!shortKey && !!targetDate) {
      
      let parents: FreedataValueVO[] = fei.model.freedataEngine.getFreedataValueByParent(code, null);
      
      if(!parents || parents?.length <= 0) { // mauvais parent
        mmi.r = '';
        mmi.isErr = true;
        return;
      }

      parents = parents.sort((a, b) => a.startDate - b.startDate);

      let goodParent: FreedataValueVO = null;
      parents.forEach(fdv => {
        if(fdv.startDate <= targetDate) { // début OK
          if(fdv.endDate) {
            if(fdv.endDate >= targetDate) {
              goodParent = fdv;
            }
          } else { // pas de date de fin
            goodParent = fdv;
          }
        } else {
          // sortie, la date est future
          return;
        }
      });

      // console.log("goodParent", goodParent);
      
      if(!goodParent) { // pas de parent, sortie
        mmi.r = '';
        mmi.isErr = true;
        return;
      }
      
      let targetFdv: FreedataValueVO = null;
      if(goodParent) {
        let possible: FreedataValueVO[] = fei.model.freedataEngine.getFreedataValueByParent(code, goodParent.code);
        possible.forEach(fdv => {
          if(fdv.shortCode === shortKey) {
            targetFdv = fdv;
            return;
          }
        });
      }
      
      // console.log("targetFdv", targetFdv);

      if(!targetFdv) { // pas de parent, sortie
        mmi.r = '';
        mmi.isErr = true;
        return;
      }
  
      const fdvKey: string = targetFdv.code; // mais on a besoin du code

      if(!fieldKey) {
        fieldKey = WizConstants.FIELD_LABEL;
      }

      let akmFDVCell: AkmFDVCell;
      // appel fake depuis trigger du FDV grid
      if(!!fei.fakeFDV && fei.fakeFDV.freeDataCode === code.split(WizConstants.CONTEXT_SEPARATOR)[0] && fei.fakeFDV.code === fdvKey) {
        akmFDVCell = { fdKey: code, fdvKey };
        // console.log('checkFDVCell got you fake', fei.fakeFDV); 
      } else {
        akmFDVCell = fei.model.cellMatrixEngine.getFDVCell(code, fdvKey, true);
      }
        
  
      if(!akmFDVCell.rawVal || !akmFDVCell[fieldKey]) { // les valeurs de base ne sont pas alimentés, ou simplement pas le champ demandé
        akmFDVCell = BaselineEngine.feedFDVCell(fei, code, fdvKey, fieldKey, akmFDVCell);
      }

      this.basicFDV(mmi, akmFDVCell, code, fieldKey, fei, line) ;    
    } else {
      mmi.r = '';
      mmi.isErr = true;
    }
  }

public static async MATRIXVAL(mmi: MeasModeItem, line: WidgetLine, fei: FeiVO): Promise<MeasModeItem> {
    
    // un double passage...
    // le 1er sera faux
    // puis mémorisation des résultat dans fei.model.cellMatrixEngine.dexieResolved
    // si existe, retour direct...
    
    // on cherche si la cellule existe
    let cell: WidgetCell = fei.model.cellMatrixEngine.getWidgetCell(line, mmi.mm.code);

    // TODO TODO si les params changent... rincer la cellule dans resolved

    // déjà résolu, on retourne le résultat
    if(fei.model.cellMatrixEngine.dexieResolved.has(cell)) {
      mmi.r = fei.model.cellMatrixEngine.dexieResolved.get(cell);
      return;
    } 
    // else {
    //   // console.log('notFound', cell, fei.model.cellMatrixEngine.dexieResolved);
    // }

    // pas encore résolu, appel dexie asynchrone

    
    const matrixKey: string = mmi.c[0].r; // la clé de matrice
    const columns: string[] = mmi.c[1].r?.split(WizConstants.KEY_SEPARATOR); // les indices de colonnes pour le critère, sous la forme 0|4|8
    const target: string = mmi.c[2].r; // la colonne cible
    
    let criterias: string[] = [];

    let fixedMmi: string[] = FunctionCoreEngine.collectToMmiContent(fei.model, mmi);
    let idx: number = 0;
    fixedMmi?.forEach((str: string) => {
      // on va faire la somme des valables
      if(idx > 2) {// on ne prends pas les 2 premiers (matrice & colonnes)
        // console.log('matrixVal', str);
        criterias.push(str);
      }
      idx++;
    });



    // c'est ça qui va être envoyé, le traitement est asynchrone
    mmi.r = null;
    // console.log('mmi.r', mmi.r);
  
    try {
      let filters: string[] = [];
      let filter: string;
      // filter(x => x[2] === 'Uni nouveauté' && x[1] === '01/09/2027' && x[4]?.toUpperCase().includes('SI'))
      
      for (let index = 0; index < columns.length; index++) {
        filter = "x['"+ columns[index] + "'] === '" + criterias[index] + "'";
        filters.push(filter);
      }

      let finalQ: string = ['filter(x =>', filters.join(' && '), ')'].join(" ");
      // let finalQ: string = ['x =>', filters.join(' && ')].join(" ");
      // console.log('MATRIXVAL finalQ', finalQ);

      let baseQuery: string = "db.table('matrixdata').where('key').equals('##INJECT##')";
      // exemple pour inject: 
      // filter(x => x[2] === 'Uni nouveauté' && x[1] === '01/09/2027' && x[4]?.toUpperCase().includes('SI'))
      let toArr: string = 'toArray()';
      let parts: string[] = [baseQuery.replace('##INJECT##', matrixKey)]; 
      parts.push(finalQ);
      parts.push(toArr);
      finalQ = parts.join(".");
      

      // console.log('MATRIXVAL finalQ', finalQ);
      fei.model.cellMatrixEngine.dexiePromises.set(cell, fei.model.matrixEngine.runQuery(cell, target, mmi.mm.m.dataKind, finalQ));
      // console.log('MATRIXVAL in dexiePromises', cell, finalQ);
      // console.log('MATRIXVAL in dexiePromises', fei.model.cellMatrixEngine.dexiePromises);
      // let result = await fei.model.matrixEngine.runQuery(cell, finalQ);
      // //   this.matrixDS.setSource(this.result);

      // if(result?.length > 0) {
      //   // console.log('result', result);
      //   mmi.r = result[0][target];
      //   console.log('result mmi', mmi.r);
      // }
    } catch(e: any) {
      console.log('MATRIXVAL Error', e);
      mmi.r = '';
      mmi.isErr = true;
    }
    
    return mmi;

  }


}
